import { getRequest } from './util';

const get = () => getRequest('/sortingDegrees');

export default {
  get,
};
